import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { copyToClipboard } from '../../helpers/copyToClipboard';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { iconCopyToCliboard } from '../../assets/icons';
import { PlainTooltip } from '../PlainTooltip';
import { FluidButton } from '../FluidButton';
import { SvgIcon } from '../SvgIcon';
import { copyableTextStyles } from './CopyableText.styles';
import { useStyles } from '../../hooks/useStyles';
export const CopyableText = createPolymorphicComponent(forwardRef(function CopyableText(props, forwardedRef) {
    const { styles, sx, innerStyles, icon, children, text, disabled, copySupportingText = 'Copy', copiedSupportingText = 'Copied!', ...other } = props;
    const { getStyles, globalStyles } = useStyles({
        name: 'CopyableText',
        styles: [copyableTextStyles, styles],
    });
    const containerHandleRef = useMergeRefs([forwardedRef]);
    const [copied, setCopied] = useState(false);
    const isTriggerVisible = !disabled;
    const handleCopy = async () => {
        const textToCopy = text ?? children?.toString();
        if (!textToCopy) {
            return;
        }
        await copyToClipboard(textToCopy);
        setCopied(true);
    };
    const handleOpen = () => setCopied(false);
    return (_jsx(PlainTooltip, { supportingText: copied ? copiedSupportingText : copySupportingText, onOpen: handleOpen, disabled: disabled, children: _jsx(FluidButton, { onClick: handleCopy, disabled: disabled, styles: innerStyles?.fluidButton, ...other, sx: [globalStyles, sx], ref: containerHandleRef, children: _jsxs("div", { ...getStyles('inner'), children: [children ? _jsx("div", { ...getStyles('text'), children: children }) : null, isTriggerVisible
                        ? (icon ?? _jsx(SvgIcon, { icon: iconCopyToCliboard }))
                        : null] }) }) }));
}));
